import { render, staticRenderFns } from "./MailIndex.vue?vue&type=template&id=c148de08"
import script from "./MailIndex.vue?vue&type=script&lang=js"
export * from "./MailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports